export default "__VITE_ASSET__e1d969ba__"